import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { connect, useSelector, useDispatch } from "react-redux";

import withStyles from '@mui/styles/withStyles';

import { PageWithAppDrawer2 } from "../_components/main/PageWithAppDrawer2";
import { utilityActions } from "../_actions";
import { Paper, Grid, Select, TextField, Button } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";

// FIXME checkout https://mui.com/components/use-media-query/#migrating-from-withwidth
const withWidth = () => (WrappedComponent) => (props) => <WrappedComponent {...props} width="xs" />;

class AdminTitleApplicationDetailsPage extends React.Component {
  constructor(props) {
    super(props);
    const { id: typeId } = this.props.match ? this.props.match.params : {};
    this.state = {
      typeId,
      reload: false,
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { id: typeId } = nextProps.match ? nextProps.match.params : {};
    if (typeId !== prevState.typeId) {
      return {
        ...prevState,
        typeId,
        reload: true,
      };
    }
    return false;
  }

  async componentDidMount() {
    // const { items: clients } = this.props.utility.client_types;
    // if (clients.length === 0) {
    //   await this.props.dispatch(
    //     utilityActions.getUtility("clients", {
    //       perPage: 1000,
    //       filters: [
    //         {
    //           field: "clientactive",
    //           operator: "eq",
    //           value: "2"
    //         }
    //       ],
    //       orders: [{ field: "clientname", direction: "asc" }]
    //     })
    //   );
    // }
  }

  render() {
    const { typeId, reload } = this.state;
    const { classes } = this.props;

    if (reload === true) {
      this.setState({ reload: false }, () => {
        this.componentDidMount();
      });
      return <></>;
    }

    return (
      <PageWithAppDrawer2 pageTitle={`Title App Type #${typeId}`}>
        <RouterLink to="/admin/titleApplicationTypes">
          All Title Application Types
        </RouterLink>
        <Paper className={classes.paper}>
          <TitleApplicationDetails itemId={typeId} />
        </Paper>
      </PageWithAppDrawer2>
    );
  }
}

function TitleApplicationDetails(props) {
  const dispatch = useDispatch();
  const item = useSelector(
    (state) => state.utility.title_application_types_item
  );
  const states = useSelector((state) => state.utility.us_states);
  const fields = [
    {
      width: 2,
      title: "Name",
      field: "titleapplicationtype",
      type: "string",
    },
    {
      width: 2,
      title: "State",
      field: "stateid",
      type: "state",
    },
    {
      width: 2,
      title: "BMV Cost",
      field: "titleapplicationcost",
      type: "string",
    },
    {
      width: 2,
      title: "Convenience Fee",
      field: "titleapplicationconvenience",
      type: "string",
    },
    {
      width: 2,
      title: "ST108 Exemption #",
      field: "exemption_number",
      type: "string",
    },
    {
      width: 2,
      title: "Requires Conforming Vehicles",
      field: "has_conforming_requirement",
      type: "selectconforming",
    },
    {
      width: 2,
      title: "Late Days (days before Late Fee is applied)",
      field: "late_fee_in_days",
      type: "number",
    },
  ];

  const id = props.itemId;

  React.useEffect(() => {
    // console.log("useEffect item", item);
    // if (item && item.paymenttype === 0) {
    //   dispatch(
    //     utilityActions.updateOneUtilityLocal("clients", {
    //       ["paymentype"]: ""
    //     })
    //   );
    // }
  }, [item]);

  React.useEffect(() => {
    if (states.items.length === 0) {
      dispatch(
        utilityActions.getUtility("us_states", {
          perPage: 1000,
          orders: [
            {
              field: "stateabbreviation",
              direction: "asc",
            },
          ],
        })
      );
    }
  }, []);

  React.useEffect(() => {
    if (id) {
      if (!item) {
        getNewData();
      } else if (Number(item.id) !== Number(id)) {
        getNewData();
      }
    }
  }, [id]);

  const getNewData = () => {
    dispatch(utilityActions.getOneUtility("title_application_types", id, []));
  };

  const updateLocal = (event) => {
    const { name, value } = event.target;
    dispatch(
      utilityActions.updateOneUtilityLocal("title_application_types", {
        [name]: value,
      })
    );
  };

  const handleSave = () => {
    dispatch(
      utilityActions.updateUtility(
        "title_application_types",
        item.id,
        item,
        () => {
          getNewData();
        }
      )
    );
  };

  return (
    <>
      {item && item.id ? (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Button variant="contained" color="primary" onClick={handleSave}>
              Save Changes
            </Button>
          </Grid>
          {fields.map((field, index) => (
            <React.Fragment key={index}>
              <Grid item xs={12} sm={4}>
                {field.title}
              </Grid>
              <Grid item xs={12} sm={8}>
                {field.type === "string" && (
                  <TextField
                    name={field.field}
                    placeholder={field.title}
                    value={item[field.field] || ""}
                    onChange={updateLocal}
                  />
                )}
                {field.type === "number" && (
                  <TextField
                    name={field.field}
                    placeholder={field.title}
                    value={item[field.field] || 0}
                    type="number"
                    onChange={updateLocal}
                    onWheel={(e) => e.target.blur()}
                  />
                )}
                {field.type === "selectconforming" && (
                  <Select
                    native
                    name={field.field}
                    value={item[field.field]}
                    onChange={updateLocal}
                    style={{ fontSize: 12 }}
                    displayEmpty
                  >
                    <option value={false}>
                      Does not require conforming vehicles
                    </option>
                    <option value={true}>Requires conforming vehicles</option>
                  </Select>
                )}
                {field.type === "state" && (
                  <Select
                    native
                    name={field.field}
                    value={item[field.field] || 1}
                    onChange={updateLocal}
                    style={{ fontSize: 12 }}
                    displayEmpty
                  >
                    <option value="">State</option>
                    {states &&
                      states.items.map((state, index) => (
                        <option key={index} value={state.stateid}>
                          {state.stateabbreviation} - {state.statefull}
                        </option>
                      ))}
                  </Select>
                )}
              </Grid>
            </React.Fragment>
          ))}
        </Grid>
      ) : (
        <CircularProgress />
      )}
    </>
  );
}

const styles = (theme) => ({
  root: {
    display: "flex",
    fontSize: 12,
  },
  content: {
    flexGrow: 1,
    height: "100vh",
    overflow: "auto",
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    width: "100%",
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    width: "100%",
  },
  fixedHeight: {
    height: 240,
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },

  Button: {
    display: "block",
    marginTop: theme.spacing(2),
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
});

function mapStateToProps(state) {
  const { authentication, utility, batch } = state;
  const { user } = authentication;
  return {
    user,
    batch,
    utility,
  };
}

const connectedAdminTitleApplicationDetailsPage = connect(mapStateToProps)(
  withWidth()(withStyles(styles)(AdminTitleApplicationDetailsPage))
);
export { connectedAdminTitleApplicationDetailsPage as AdminTitleApplicationDetailsPage };
